module.exports = __webpack_public_path__ + "img/bottom_right_entry.06894f29.png";